export enum DocumentType {
IdCard,
Passport,
}
